// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { BSETBase } from '../Classes/BSETBase';
import { IGuid } from '../Interfaces/IGuid';
import { ISalesOffice } from '../Interfaces/ISalesOffice';
export class Task extends BSETBase implements IGuid, ISalesOffice {
  allowSalesOfficeChange: boolean;
  isWbsApplied: boolean;
  isLaborHourEditAllowedForPM: boolean;
  isLaborHourEditAllowedForMech: boolean;
  isLaborHourEditAllowedForElec: boolean;
  isLaborHourEditAllowedForEng: boolean;
  isLaborHourEditAllowedForSpec: boolean;
  oldSuspendPropertyChange: boolean;
  taskAddedAfterTotalAdjustment: boolean;
  canApplyDefaultWBSOffice: boolean;
  oldDescription: string;
  declare guid: string;
  salesOfficeId: number;
  isEngTask: boolean;
  isPMLaborRateUnavailable: boolean;
  isENGLaborRateUnavailable: boolean;
  isNENGLaborRateUnavailable: boolean;
  isQENGLaborRateUnavailable: boolean;
  isCENGLaborRateUnavailable: boolean;
  isEENGLaborRateUnavailable: boolean;
  isLENGLaborRateUnavailable: boolean;
  isProgLaborRateUnavailable: boolean;
  isGrapLaborRateUnavailable: boolean;
  isDDSLaborRateUnavailable: boolean;
  isSPECLaborRateUnavailable: boolean;
  isMECHLaborRateUnavailable: boolean;
  isELECLaborRateUnavailable: boolean;
}
